/* eslint-disable indent */
// Feature-specific, shared styles contained here
import styled from '@emotion/styled';

import { colors } from 'ui_system/compass';
// Theme is a js object containing global values such as colors, widths.
import { Theme } from 'ui_system/theme';

export { Theme };

/* Generic flexbox helpers ===== */
// Horizontal flexbox
export const HFlex = styled.div`
  display: flex;
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'center')};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : 'space-between'};
`;

// Vertical flexbox
export const VFlex = styled.div`
  flex-direction: column;
  display: flex;
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'center')};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : 'space-between'};
`;
/* ===== */

// Horizontal line / divider
export const HR = styled.hr`
  border: none;
  height: 1px;
  margin-bottom: 50px;
  background: ${colors.border};

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    margin-bottom: 30px;
  }
`;

export const Text = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.center ? 'center' : 'flex-start')};
  font-weight: ${(props) => (props.bold ? '600' : '400')};
  color: ${(props) => (props.color ? props.color : colors.text.primary)};
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : 'default')};

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: ${(props) =>
      props.mobileFontsize ? `${props.mobileFontsize}px` : 'default'};
  }

  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : '0px'};

  text-decoration: ${(props) => (props.underline ? 'underline' : 'default')};

  &:hover {
    cursor: ${(props) => (props.hover ? 'pointer' : 'inherit')};
  }
`;

export const GreenButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.primary};
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 25px;
  padding-left: 25px;
  font-weight: 400;
  border-radius: 4px;
  color: white;
  font-size: 14px;

  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  opacity: ${(props) => (props.disabled ? '0.3' : '1')};

  :hover {
    background-color: ${Theme.colors.buttonHoverColor};
  }

  i {
    font-size: 14px;
    line-height: 14px;
    margin-right: 10px;
    font-weight: 600;
  }

  border: none;
`;

export const GreenOutlineButton = styled(GreenButton)`
  background-color: white;
  color: ${colors.primary};
  border: 1px solid ${colors.primary};
  outline: none;
  :hover {
    color: white;
  }
`;

export const ActionButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  border: 1px solid
    ${(props) => (props.red ? Theme.colors.red : colors.primary)};
  color: ${(props) => (props.red ? Theme.colors.red : colors.primary)};
  font-size: 16px;
  font-weight: 400;
  text-overflow: ellipsis;
  text-align: center;
  border-radius: 4px;
  width: 100%;
  max-width: 170px;

  opacity: ${(props) => (props.disabled ? '0.3' : '1')};
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
`;

// Table styles  =====
export const Table = styled.div`
  display: block;
  width: 100%;
`;

export const FilterBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  font-size: 16px;
`;

export const TableRow = styled.div`
  display: table;
  table-layout: fixed;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 16px;
  width: 100%;
  color: ${colors.text.secondary};
  border-bottom: 1px solid ${colors.border};
  cursor: ${(props) => (props.hover ? 'pointer' : 'default')};
`;

export const TableHeader = styled(TableRow)`
  font-weight: 600;
  color: black;
  background-color: ${colors.background.light};
`;

export const TableItem = styled.div`
  display: table-cell;
  text-align: center;
  vertical-align: middle;

  color: ${(props) => (props.green ? colors.primary : colors.text.primary)};
  cursor: ${(props) => (props.hover ? 'pointer' : 'default')};
  font-weight: ${(props) => (props.bold ? '600' : 'default')};

  padding-left: ${(props) =>
    props.paddingLeft ? `${props.paddingLeft}px` : 'default'};

  width: ${(props) => (props.width ? `${props.width}%` : 'unset')};
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : 'inherit')};

  color: ${colors.text.primary};
  text-align: ${(props) => {
    if (props.left) {
      return 'left';
    }
    if (props.right) {
      return 'right';
    }
    if (props.center) {
      return 'center';
    }
    return 'center';
  }};
`;

// Empty table state for list views
export const EmptyTable = styled.div`
  color: ${colors.text.secondary};
  padding-top: 100px;
  text-align: center;
`;
// ===== Table styles
